import React from 'react';

import { LENDER_ADDRESS_LINE_2 } from '../../constants';
import LenderAddressTextField from './LenderAddressTextField.interstate';

const LenderStreetAddress2Field = () => (
    <LenderAddressTextField
        id="LenderStreetAddress2Field"
        dataTestId="lender-street-address-2"
        label={LENDER_ADDRESS_LINE_2}
        name="lender-street-address-2"
        field="line2"
    />
);

export default LenderStreetAddress2Field;
